import React, { Component } from "react";

import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import calcularPx from "./calcularPx.js";

import background from "../../res/banners/banner.png";
import NavBar from "./navBar/navBar.jsx";
import Home from "../home/paginaHome.jsx";
import Contacto from "../contacto/paginaContacto.jsx";
import NotFound from "./paginaNotFound.jsx";
import Footer from "./footer/footer.jsx";
import ContactoExito from "../contacto/paginaContactoExito.jsx";

class Sitio extends Component {
  state = {
    width: 0,
    cargo: false,
  };

  constructor(props) {
    super(props);
    this.actualizarAncho = this.actualizarAncho.bind(this);
  }

  componentDidMount() {
    this.actualizarAncho();
    window.addEventListener("resize", this.actualizarAncho);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.actualizarAncho);
  }

  actualizarAncho() {
    this.setState({
      width: typeof window !== "undefined" ? window.innerWidth : 0,
    });
  }

  render() {
    return (
      <div>
        <div
          style={{
            position: "relative",
            minHeight: "calc(100vh - " + calcularPx(303.49) + ")",
            backgroundImage: `url(${background})`,
          }}
        >
          <NavBar/>
          <Routes>
            <Route
              path="/es/contact/success"
              element={
                <ContactoExito idioma={"es"}/>
              }
            />
            <Route
              path="/en/contact/success"
              element={
                <ContactoExito idioma={"en"}/>
              }
            />
            <Route path="/es/contact" element={<Contacto idioma={"es"}/>} />
            <Route path="/en/contact" element={<Contacto idioma={"en"}/>} />
            <Route path="/contacto" element={<Navigate to="/es/contact" />} />
            <Route path="/contact" element={<Navigate to="/en/contact" />} />

            <Route path="/es/home" element={<Home idioma={"es"}/>} />            
            <Route path="/en/home" element={<Home idioma={"en"}/>} />  
            <Route path="/home" element={<Navigate to="/en/home" />} />

            <Route path="/es" element={<Navigate to="/es/home" />} />
            <Route path="/en" element={<Navigate to="/en/home" />} />
            <Route path="/" element={<Navigate to="/es/home" />} />

            <Route path="/es/404" element={<NotFound idioma={"es"}/>} />
            <Route path="/en/404" element={<NotFound idioma={"en"}/>} />
            <Route path="/es/*" element={<Navigate to="/es/404" />} />
            <Route path="/en/*" element={<Navigate to="/en/404" />} />
            <Route path="*" element={<Navigate to="/es/404" />} />
          </Routes>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Sitio;
